import {
  LiveCallsIcon,
  SmsIcon,
  ContactsIcon,
  ReportIcon,
  PbxPortalIcon,
  CallCenterIcon,
} from 'assets';

import type { ReactNode } from 'react';

export interface AppMetadata {
  key: string; // kebab-case route segment
  title: string;
  icon: ReactNode;
}

export const APP_METADATA: AppMetadata[] = [
  {
    key: 'live-calls',
    title: 'Live Calls',
    icon: <img src={LiveCallsIcon} alt="Live Calls" />,
  },
  {
    key: 'call-center',
    title: 'Call Center',
    icon: <img src={CallCenterIcon} alt="Call Center" />,
  },
  {
    key: 'sms',
    title: 'SMS',
    icon: <img src={SmsIcon} alt="SMS" />,
  },
  {
    key: 'contacts',
    title: 'Contacts',
    icon: <img src={ContactsIcon} alt="Contacts" />,
  },
  {
    key: 'reports',
    title: 'Report',
    icon: <img src={ReportIcon} alt="Reports" />,
  },
  {
    key: 'pbx-portal',
    title: 'PBX Portal',
    icon: <img src={PbxPortalIcon} alt="PBX Portal" />,
  },
];
